export default __webpack_public_path__ + "static/media/matcap_glossy_03.df11d689.jpg";